"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContext = void 0;
const react_1 = require("react");
exports.ModalContext = react_1.createContext({
    onClose: () => { },
    inModal: false,
    isOpen: false,
});
exports.ModalContext.displayName = 'ModalContext';
